import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import useThemeMode from "../../hooks/useThemeMode";
import { getMarketingTheme } from "../../utils/marketingTheme";
import useI18n from "../../i18n/useI18n";

const AboutCTA = () => {
  const { isDark } = useThemeMode();
  const { t } = useI18n();
  const colors = useMemo(() => getMarketingTheme(isDark), [isDark]);

  const tt = (key, fallback) => {
    const value = t(key);
    return value === key ? fallback : value;
  };

  return (
    <section style={{ padding: "0 20px 84px", background: colors.sectionBg }}>
      <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
        <div
          style={{
            background: colors.darkCtaBg,
            color: "#ffffff",
            borderRadius: "30px",
            padding: "36px 28px",
            boxShadow: colors.shadow,
          }}
        >
          <div style={{ maxWidth: "760px" }}>
            <div
              style={{
                display: "inline-flex",
                padding: "7px 12px",
                borderRadius: "999px",
                background: "rgba(255,255,255,0.12)",
                color: "#e0e7ff",
                fontWeight: "700",
                fontSize: "12px",
                marginBottom: "16px",
              }}
            >
              {tt("about.ctaBadge", "Start with Hookora")}
            </div>

            <h2
              style={{
                margin: "0 0 12px",
                fontSize: "clamp(2rem, 4vw, 3rem)",
                lineHeight: "1.08",
              }}
            >
              {tt(
                "about.ctaTitle",
                "Build your content workflow with more clarity and less friction"
              )}
            </h2>

            <p
              style={{
                margin: "0 0 22px",
                color: colors.darkCtaMuted,
                lineHeight: "1.75",
                fontSize: "16px",
                maxWidth: "660px",
              }}
            >
              {tt(
                "about.ctaDescription",
                "If you want a cleaner way to generate hooks, titles, captions, scripts, and more, Hookora gives you a practical place to start."
              )}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                flexWrap: "wrap",
              }}
            >
              <Link
                to="/register"
                style={{
                  textDecoration: "none",
                  background: "#ffffff",
                  color: "#111827",
                  padding: "14px 18px",
                  borderRadius: "12px",
                  fontWeight: "800",
                }}
              >
                {tt("about.createFreeAccount", "Create Free Account")}
              </Link>

              <Link
                to="/pricing"
                style={{
                  textDecoration: "none",
                  background: "transparent",
                  color: "#ffffff",
                  padding: "14px 18px",
                  borderRadius: "12px",
                  fontWeight: "800",
                  border: "1px solid rgba(255,255,255,0.24)",
                }}
              >
                {tt("about.viewPricing", "View Pricing")}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCTA;